import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/UpToDateIllustration.tsx
const UpToDateIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "up-to-date.svg",
		alt: t("illustration.imageAlt.upToDate")
	});
};

//#endregion
export { UpToDateIllustration };